import React from "react";
import { Helmet } from "react-helmet-async";

const SITE_URL = process.env.REACT_APP_SITE_URL || "";

function withLeadingSlash(path) {
  if (!path) {
    return "";
  }
  return path.startsWith("/") ? path : `/${path}`;
}

export default function Seo({
  title,
  description,
  canonicalPath,
  image = "/laserBrosLogo.png",
  noindex = false,
  structuredData = [],
}) {
  const canonicalUrl = canonicalPath
    ? `${SITE_URL}${withLeadingSlash(canonicalPath)}`
    : SITE_URL;

  const robots = noindex ? "noindex,nofollow" : "index,follow";

  const ogImageUrl = image.startsWith("http")
    ? image
    : `${SITE_URL}${withLeadingSlash(image)}`;

  return (
    <Helmet>
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      <meta name="robots" content={robots} />
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}

      <meta property="og:type" content="website" />
      {title && <meta property="og:title" content={title} />}
      {description && <meta property="og:description" content={description} />}
      {canonicalUrl && <meta property="og:url" content={canonicalUrl} />}
      {ogImageUrl && <meta property="og:image" content={ogImageUrl} />}

      <meta name="twitter:card" content="summary_large_image" />
      {title && <meta name="twitter:title" content={title} />}
      {description && <meta name="twitter:description" content={description} />}
      {ogImageUrl && <meta name="twitter:image" content={ogImageUrl} />}

      {structuredData.map((schema, index) => (
        <script key={index} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
}

